export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'remen-tuijian',
    name: '热门推荐',
    description: '最受读者欢迎的韩国漫画推荐，每日更新热门榜单',
    icon: 'ri-fire-line',
  },
  {
    slug: 'lianai-manhua',
    name: '恋爱漫画',
    description: '甜蜜浪漫的韩国恋爱漫画，感受心动瞬间',
    icon: 'ri-heart-line',
  },
  {
    slug: 'dongzuo-manhua',
    name: '动作漫画',
    description: '热血刺激的韩国动作漫画，精彩打斗场面',
    icon: 'ri-flashlight-line',
  },
  {
    slug: 'qihuan-manhua',
    name: '奇幻漫画',
    description: '充满想象力的韩国奇幻漫画，开启异世界冒险',
    icon: 'ri-magic-line',
  },
  {
    slug: 'xuanyi-manhua',
    name: '悬疑漫画',
    description: '扣人心弦的韩国悬疑漫画，烧脑反转不断',
    icon: 'ri-search-eye-line',
  },
  {
    slug: 'gaoxiao-manhua',
    name: '搞笑漫画',
    description: '轻松幽默的韩国搞笑漫画，欢乐解压首选',
    icon: 'ri-emotion-laugh-line',
  },
  {
    slug: 'dushi-manhua',
    name: '都市漫画',
    description: '贴近生活的韩国都市漫画，演绎现代故事',
    icon: 'ri-building-line',
  },
  {
    slug: 'gufeng-manhua',
    name: '古风漫画',
    description: '唯美古风的韩国历史漫画，穿越时空的浪漫',
    icon: 'ri-pen-nib-line',
  },
];